import {
  getPostScene,
  getStoryScene,
} from '@src/api/services/JobCreativesService';
import { type Job } from '@src/api/services/JobService';
import { Paths } from '@src/paths';
import { type LoaderFunction, redirect } from 'react-router-dom';

export type CreativeBuilderForJobViewLoaderData = {
  type: 'post' | 'story';
  sceneFile: Promise<Job['scenes']['post']>;
  jobId: string;
};

export const creativeBuilderForJobViewLoader: LoaderFunction = ({
  params,
  request,
}) => {
  if (
    !('jobId' in params) ||
    typeof params.jobId !== 'string' ||
    !params.jobId
  ) {
    return redirect(Paths.ROOT);
  }
  const { jobId } = params;
  const url = new URL(request.url);
  const type = url.searchParams.get('type');
  if (!type) {
    return redirect(getRedirectUrl(jobId));
  }

  const sceneFile =
    type === 'post' ? getPostScene(jobId) : getStoryScene(jobId);

  return {
    type,
    sceneFile,
    jobId,
  };
};

const getRedirectUrl = (jobId: string) =>
  Paths.JOB_DETAILS.replace(':jobId', jobId);
